<template>
  <div class="link-section">
    <div class="columns is-align-items-center margin-0">
      <div class="column is-3-mobile is-5-desktop is-5-widescree p-y-0 p-x-0">
        <div class="level">
          <div class="level-left">
            <div class="page-layout-head">{{currentRelevantRoute.type === `whatsapp` ? `WhatsApp` : `Landing Page`}} Share Link</div>
          </div>
        </div>
      </div>
    </div>
    <hr class="page-layout-horizontal-row">
    <div class="share-link-section">
      <div class="page-subtitle">
        <span v-if="currentRelevantRoute.type === `landingpage`">Send out your review share link, or embed in your email signature so that your customers can easily review your business.</span>
        <span v-if="currentRelevantRoute.type === `whatsapp`">Your customers can now publish reviews on the go by sending their reviews via WhatsApp. Easily collect reviews by sharing your unique WhatsApp link.</span>
      </div>
      <div class="columns">
        <div class="column has-text-centered is-paddingless is-one-fifth share-card-section" v-if="currentRelevantRoute.type === `landingpage`">
          <div class="column background">
            <img src="/static/img/review-invites/review-invite-link.svg" alt="review-invite-link">
          </div>
          <div class="column is-narrow tile-title">Landing Page</div>
          <div class="column is-narrow is-paddingless tile-description">Leave a review on our HP landing page</div>
          <div class="column is-narrow">
            <button class="button is-button-dark-blue is-uppercase tile-button" @click="copyLink('bizUrl')">Copy Link</button>
          </div>
        </div>
        <div class="column has-text-centered is-paddingless is-one-fifth share-card-section whatsapp-section" v-if="currentRelevantRoute.type === `whatsapp`">
          <div class="column background">
            <img src="/static/img/review-invites/whatsapp-review-invite-link.png" alt="review-invite-link" height="70" width="70">
          </div>
          <div class="column is-narrow tile-title">WhatsApp</div>
          <div class="column is-narrow is-paddingless tile-description">Leave a review on our WhatsApp channel</div>
          <div class="column is-narrow">
            <button class="button is-button-dark-blue is-uppercase tile-button" @click="copyLink('whatsAppLink')">Copy Link</button>
          </div>
        </div>
      </div>
    </div> <!-- Share link section ends -->
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import axios from 'axios'
  import Misc from './../../mixins/misc.js'
  export default {
    name: 'ReviewsShare',
    metaInfo: {
      title: 'Business Portal | Hellopeter - Share Review Invites'
    },
    mixins: [Misc],
    data () {
      return {
        file: '',
        businessSlug: localStorage.getItem('org_slug'),
        businessName: localStorage.getItem('org_name'),
        consumerFrontendUrl: process.env.HP_APP_URL,
        is_loading: false,
        fetching_data: false,
        keyword_search: undefined,
        activeSubscription: {}
      }
    },
    computed: {
      businessCopyUrl () {
        const source = 'UE9SVEFMX0NPUFlfTElOS19JTlZJVEU%3D'
        return `${this.consumerFrontendUrl}/write-a-review/${this.businessSlug}?source=${source}&r=true`
      },
      /**
       * Whatsapp review invite link
       * @returns {string}
       */
      whatsAppInviteURL () {
        return `https://wa.me/27212066516?text=${encodeURIComponent('To start writing a review about ')}${encodeURIComponent(this.businessName)}${encodeURIComponent(' PRESS SEND')}`
      },
      /**
       * Get whats the current route (Whatsapp/Landingpage)
       * @returns {object}
       */
      currentRelevantRoute () {
        return this.$route.query
      }
    },
    created () {
      this.getReviewInvitationsHistory(null)
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Marketing Collect Reviews'
      })
    },
    methods: {
      copyLink (linkType = 'bizUrl') {
        let url = linkType === 'bizUrl' ? this.businessCopyUrl : this.whatsAppInviteURL
        this.$copyText(url)
          .then(() => {
            flash(`Successfully copied '${url}' to your clipboard`, 'is-success')
            dataLayer.push({
              'userMessage': {
                'messageType': 'success',
                'messageName': 'Successfully copied business URL to clipboard on Collect Reviews View',
                'displayedMessage': `Successfully copied '${this.businessCopyUrl}' to your clipboard`
              }
            })
          })
      },
      /**
       * Make request to api to get review invites history
       * @returns {number | null}
       * @param {number} page page number to paginate to
       */
      getReviewInvitationsHistory (page) {
        this.page = page
        this.fetching_data = true
        axios.get(this.url(page, this.keyword_search))
          .then((response) => {
            response.data.data = undefined
            this.is_loading = false
            this.fetching_data = false
            this.activeSubscription = response.data.activeSubscription
          })
          .catch(() => {
            flash('You are not authorized to view this resource.', 'is-danger')
            this.is_loading = false
            this.fetching_data = false
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed to get Review Invitation History on Collect Reviews View due to authorization error',
                'displayedMessage': 'You are not authorized to view this resource.'
              }
            })
          })
      },
      /**
       * Compute URI to make call to api with.
       * @param {string} page starting page to request
       * @param {string} keyword search keyword
       * @return {string}
       */
      url (page, keyword) {
        let query = location.search.match(/page=(\d+)/)
        if (!page) {
          page = query ? query[1] : 1
        }
        return `/marketing/${this.businessSlug}/get-review-invitation-history/?page=${page}`
      }
    }
  }
</script>

<style scoped>
  .report-row {
    background-color: #F5F5F5;
  }

  .section {
    padding: 1.5rem;
    margin: 0.75rem 0.75rem 0.75rem 0;
  }

  .benchmarking {
    margin-top: 2.75rem;
  }

  .generic {
    margin-top: 1.75rem;
  }

  .level.is-mobile .level-item:last-child {
    margin-right: 0;
  }

  .level:not(:last-child) {
    margin-bottom: 0;
  }

  .mar-top {
    margin-top: 1rem;
  }

  .mail-list {
    background-color: #F5F5F5;
    padding-top: 20px;
    padding-bottom: 20px;
    display: inline-block;
  }

  @media screen and (max-width: 767px) {
    .section {
      padding: 1rem 0.75rem;
    }
    .buttons .button:not(:last-child) {
      margin-right: 0;
    }
  }

  #back-to-results > a {
    text-decoration: none;
    color: #2aabe1;
  }

  .router-link-active {
    background: none !important;
  }

  .buttons .button {
    /*margin-bottom: 0;*/
  }
  .manage-csv-btn {
    margin-top: 19px;
  }
  .or-text {
    margin-right: 17px;
    margin-left: 17px;
  }
  .isBtnsActive {
    pointer-events: none;

    /* for "disabled" effect */
    opacity: 0.5;
    /*background: #fff;*/
  }
  .input-email {
    flex:0 0 79%;
  }
  .input-email input{
    height: 39px;
  }
  .fielld-new {
    display: flex;
    width:100%;
    flex-wrap: wrap;
  }
  .fielld-new  .buttons:last-child{
    /*margin:0px;*/
  }
  .level-left.left-section {
    /*width: 100%;*/
  }
  .columns.is-mobile{
    width:100%;
  }
  .remove-file {
    text-decoration: underline;
  }
  .italic-style {
    font-size: 0.875em;
  }
  .direction-column {
    flex-direction: column;
    align-items: flex-start;
  }
  .page-layout-head {
    color: #58595b;
    font-size: 12px;
    font-weight: bold;
  }
  .page-layout-horizontal-row {
    margin-left: -33px;
    margin-right: -26px;
    margin-top: 10px;
  }
  .share-link-section .page-subtitle {
    color: #58595b;
    margin: 0 0 15px 0;
    font-size: 12px;
  }
  .share-link-section .text-box .text span {
    color: #58595b;
    font-size: 12px;
  }
  .share-link-section .text-box .text {
    padding: 5px 12px;
    border: solid 1px rgba(88, 89, 91, 0.32);
    background-color: #ffffff;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }
  .share-link-section .text-box button {
    width: 32%;
    border-radius: 2px;
    text-transform: uppercase;
  }
  .share-link-section .text-box .padding-0 {
    padding: 0;
  }
  .share-card-section {
    min-width: 295px;
    border: solid 1px rgba(216, 216, 216, 0.32);
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 16%);
  }
  .share-card-section.whatsapp-section {
    /*margin: 0 0 0 12px;*/
  }
  .share-card-section .background {
    padding: 30px;
    background: url('/static/img/review-invites/mask-group-267.png');
  }
  .share-card-section .tile-title {
    color: #8a8c91;
    font-size: 14px;
    font-weight: bold;
  }
  .share-card-section .tile-description {
    color: #8a8c91;
    font-size: 12px;
    font-weight: normal;
  }
  .share-card-section .tile-button {
    width: 130px;
    height: 35px;
  }
  @media screen and (max-width: 767px) {
    .link-section {
      padding: 30px;
    }
    .share-link-section .text-box button {
      width: auto;
    }
    .share-card-section.whatsapp-section {
      margin: 12px 0 0 0;
    }
  }
</style>
<style>
  div#sideBar .is-padding-top-0 {
    padding-top: 0;
  }
  .share-link {
    color: #58595b;
    font-size: 12px;
    width: 500px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/pages/collect-reviews/ReviewsShare.vue